import { render, staticRenderFns } from "./portal.vue?vue&type=template&id=6ba69ae2&scoped=true"
import script from "./portal.vue?vue&type=script&lang=js"
export * from "./portal.vue?vue&type=script&lang=js"
import style0 from "./portal.vue?vue&type=style&index=0&id=6ba69ae2&prod&lang=scss&scoped=true"
import style1 from "./portal.vue?vue&type=style&index=1&id=6ba69ae2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba69ae2",
  null
  
)

export default component.exports